import { type ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Card({ children, className = '', onClick }: CardProps): JSX.Element {
  const baseStyles = [
    'bg-surface-elevated',
    'rounded-card',
    'border border-border-subtle',
    'shadow-subtle',
    'p-4',
  ].join(' ');

  const interactiveStyles = onClick
    ? 'cursor-pointer hover:bg-surface-subtle transition-colors duration-150'
    : '';

  return (
    <div
      className={`${baseStyles} ${interactiveStyles} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
}
